export default "__VITE_ASSET__BtfqnOfy__"